import React, { useCallback, useEffect, useState } from 'react';
import { Col, Form, Input, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import {
  BlueLayout,
  CustomButton,
  CustomGoBackButton,
  FormBlock,
  FormInput,
  FormItem,
  PagesContainerUI,
} from '../../styles/styled';
import { DocumentFileForm } from '../EditDocumentCategoryPage/components/DocumentFileForm/DocumentFileForm';
import { ChangesDocumentType, DocumentFileType, DocumentType } from '../EditDocumentCategoryPage/types';

const { TextArea } = Input;

export const DocumentEditPage = () => {
  const [currentDocumentState, setCurrentDocument] = useState<DocumentType | null>(null);
  const [formDocumentState, setFormDocumentState] = useState<DocumentType | null>(null);
  const [updateDocument, setUpdate] = useState<boolean>(false);
  const [changesState, setChangesState] = useState<ChangesDocumentType>({});
  const [removeDocIds, setRemoveDocIds] = useState<number[]>([]);

  const { id } = useParams();
  const navigate = useNavigate();

  const escFunction = useCallback((event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          const response = await api.get<DocumentType>(endpoints.getDocumentById(id));

          setCurrentDocument(response.data);
          setFormDocumentState(response.data);
        }
      } catch (err) {}
    })();
  }, [id]);

  useEffect(() => {
    if (updateDocument && id) {
      (async () => {
        try {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const { document_files, ...changes } = changesState;
          const response = await api.put(endpoints.deleteDocumentId({ id: id }), changes);

          removeDocIds.map(async (el) => {
            const removeDocumentFileResponse = await api.delete(endpoints.deleteDocumentFileId(el));

            return !!removeDocumentFileResponse;
          });

          document_files?.map(async (el) => {
            const documentFilesResponse = await api.put(endpoints.changeDocumentFile(el.id), {
              sort: el.sort,
              name: el.name,
              expire: el.expire,
              file: el.file,
            });

            return !!documentFilesResponse;
          });

          if (response) navigate(-1);

          setUpdate(false);
        } catch (err) {}
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateDocument]);

  return (
    <PagesContainerUI>
      <BlueLayout>
        <div className="go-back">
          <CustomGoBackButton onClick={() => navigate(-1)}>{'<'}</CustomGoBackButton>
        </div>
        {currentDocumentState?.title}
      </BlueLayout>
      <Form>
        <FormBlock white>
          <Row gutter={[20, 40]}>
            <Col span={24}>
              <FormItem redstar>
                <p>Наименование</p>
                <FormInput
                  onChange={(e) => {
                    formDocumentState && setFormDocumentState({ ...formDocumentState, title: e.target.value });
                    setChangesState({ ...changesState, title: e.target.value });
                  }}
                  value={formDocumentState?.title}
                />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem>
                <p>Содержание</p>
                <TextArea
                  onChange={(e) => {
                    formDocumentState && setFormDocumentState({ ...formDocumentState, content: e.target.value });
                    setChangesState({ ...changesState, content: e.target.value });
                  }}
                  value={formDocumentState?.content}
                />
              </FormItem>
            </Col>
            {formDocumentState &&
              formDocumentState.document_files.map((el) => (
                <Col span={24} key={el?.id}>
                  <DocumentFileForm
                    setForm={(id: number, res: DocumentFileType) => {
                      setFormDocumentState({
                        ...formDocumentState,
                        document_files: formDocumentState.document_files.map((el) => {
                          return el.id === id ? res : el;
                        }),
                      });

                      setChangesState({
                        ...changesState,
                        document_files: formDocumentState.document_files
                          ? formDocumentState.document_files.map((el) => (el.id === id ? res : el))
                          : [res],
                      });
                    }}
                    removeForm={(id: number) => {
                      setFormDocumentState({
                        ...formDocumentState,
                        document_files: formDocumentState.document_files.filter((el) => el.id !== id),
                      });
                      setRemoveDocIds([...removeDocIds, id]);
                      setChangesState({
                        ...changesState,
                        document_files:
                          changesState.document_files && changesState.document_files.filter((el) => el.id !== id),
                      });
                    }}
                    fileData={el}
                  />
                </Col>
              ))}
          </Row>
          <br />

          <CustomButton
            onClick={() =>
              formDocumentState &&
              setFormDocumentState({
                ...formDocumentState,
                document_files: [
                  ...formDocumentState?.document_files,
                  {
                    sort: 0,
                    expire: false,
                    id: Math.floor(Math.random() * (1999 - 1) + 1),
                  },
                ],
              })
            }
            width="250px"
            lined
          >
            Добавить файл
          </CustomButton>
          <div className="to-center">
            <CustomButton onClick={() => setUpdate(true)}>Сохранить</CustomButton>
          </div>
        </FormBlock>
      </Form>
    </PagesContainerUI>
  );
};
